// news ticker componet that scrolls children array vertically
// use like this:
// <NewsTicker>
//  <div>children 1</div>
//  <div>children 2</div>
//  <div>children 3</div>
//  <div>children 4</div>
// </NewsTicker>

import React, { useEffect, useRef, useState } from 'react'
import useInterval from '@hooks/use-interval'
import { Box, Flex } from '@chakra-ui/react'

export const NewsTicker = ({
  children,
  speed = 1000,
  delay = 1000,
  direction = 'down',
  align = 'center',
}: {
  children: React.ReactNode
  speed?: number
  delay?: number
  direction?: 'up' | 'down'
  align?: 'center' | 'left' | 'right'
}) => {
  const [top, setTop] = useState(0)
  const [index, setIndex] = useState(0)
  const containerRef = useRef<HTMLDivElement>(null)
  const [containerHeight, setContainerHeight] = useState(0)
  const [hover, setHover] = useState(false)
  const scroll = () => {
    const height = containerRef.current?.clientHeight || 0
    setContainerHeight(height)
    if (direction === 'down') {
      if (top === 0) {
        setTop(-height)
      } else {
        setTop(0)
      }
    } else if (direction === 'up') {
      if (top === 0) {
        setTop(height)
      } else {
        setTop(0)
      }
    }
  }

  const next = () => {
    if (hover) return
    if (index === React.Children.count(children) - 1) {
      setIndex(0)
    } else {
      setIndex(index + 1)
    }
  }

  useInterval(() => {
    next()
    scroll()
  }, speed)

  useEffect(() => {
    setTimeout(() => {
      scroll()
    }, delay)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index])

  return (
    <Flex overflow="hidden" position="relative">
      <Box
        // position="absolute"
        top={0}
        left={0}
        width={'100%'}
        transition={'top 0.5s'}
        style={{ top }}
        ref={containerRef}
        onMouseEnter={() => setHover(true)}
        onMouseLeave={() => setHover(false)}
      >
        {React.Children.map(children, (child, i) => (
          <div
            style={{
              display: i === index ? 'block' : 'none',
              textAlign: align,
            }}
          >
            {child}
          </div>
        ))}
      </Box>
    </Flex>
  )
}


export default NewsTicker
